import { trDuz } from '../kilavuz/fihrist';

/**
 * Yazdıkça arama eşleşmesi: Türkçe harf duyarsız (İ/ı, ş, ğ, ü, ö, ç), kelimelerin HEPSİ geçmeli.
 * Dönen sayı sıralama içindir (küçük = daha iyi): 0 ad başında, 1 adda, 2 yalnız ek kelimelerde; eşleşme yoksa -1.
 */
export function eslesme(q: string, ad: string, ek: string[] = []): number {
  const kelimeler = trDuz(q).split(' ').filter(Boolean);
  if (kelimeler.length === 0) return -1;
  const a = trDuz(ad);
  const hepsi = `${a} ${ek.map(trDuz).join(' ')}`;
  if (!kelimeler.every((k) => hepsi.includes(k))) return -1;
  if (a.startsWith(kelimeler[0])) return 0;
  return kelimeler.every((k) => a.includes(k)) ? 1 : 2;
}

/** Sayfadaki `#id` öğesine iner ve kısa süre vurgular. Öğe sonradan yükleniyorsa birkaç kez dener. */
export function capayaGitVurgula(id: string): () => void {
  let bitti = false;
  const zamanlar: number[] = [];
  const dene = (kalan: number) => {
    if (bitti) return;
    const el = document.getElementById(id);
    if (!el) { if (kalan > 0) zamanlar.push(window.setTimeout(() => dene(kalan - 1), 200)); return; }
    // Girdi alanında vurgu, alanın etiketiyle birlikte kutusuna verilir.
    const hedef = (/^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName) ? el.closest<HTMLElement>('.ccd-field, .ccd-site-alan') : null) ?? el;
    hedef.scrollIntoView({ block: 'center', behavior: 'auto' });
    hedef.classList.add('ccd-vurgu');
    zamanlar.push(window.setTimeout(() => hedef.scrollIntoView({ block: 'center', behavior: 'auto' }), 450));
    zamanlar.push(window.setTimeout(() => hedef.classList.remove('ccd-vurgu'), 3200));
  };
  dene(15);
  return () => { bitti = true; zamanlar.forEach((z) => window.clearTimeout(z)); };
}
